import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { propertyAttributeServices } from '../services/propertyAttribute.service';

export const useDeletePropertyAttribute = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => propertyAttributeServices.deletePropertyAttribute(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['property-attributes']);
      toast.success('Attribute deleted successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to delete attribute');
    },
  });
};
